export const MIN_TOTAL_ORDERS = 2;
export const MAX_TOTAL_ORDERS = 50;
